




import { Component, Vue } from 'vue-property-decorator';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'JdFaceSuccess'
})

export default class JdFinanceSignSuccess extends Vue {
  path = '';

  mounted() {
    this.path = getUrlParam('path');
    console.log('path', this.path);
    console.log(navigator.userAgent);

    this.toJdMp();
  }

  toJdMp() {
    setTimeout(() => {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      // jd.miniProgram.navigateBack();

      // @ts-ignore
      // eslint-disable-next-line no-undef
      jd.miniProgram.navigateTo({
        url: this.path
      });
    }, 300);
  }
}

